import { combineReducers } from "@reduxjs/toolkit";
import GameSlice from "../services/GameSlice";
import NotificationSlice from "../services/NotificationSlice";

const appReducer = combineReducers({
    game: GameSlice,
    notificationHandler: NotificationSlice
})

const rootReducer = (state, actions) => {
    return appReducer(state, actions)
}

export default rootReducer;